import PropTypes from 'prop-types';
import React from 'react';

/**
 * Generates dynamic narrations
 * @param {Object} data
 * @param {String} data.text
 * @param {Array} data.values
 * @returns {HTMLParagraphElement} HTML "\<p\>" tag
 */
export default function GenerateNarration({ data }) {
  try {
    // split nattation string with ###.
    const initialArray = data.text.split('###');
    const finalArray = [];
    let currentIndex = -1;

    // After every string in the split array, set aside an index with 1 element for dynamic values.
    initialArray.forEach((element, index) => {
      if (index === initialArray.length - 1 && element === '') return;
      finalArray.push(element.trim());
      finalArray.push(1);
    });

    // finalArray has reserved indexes for dynamic values in order along with portions of narration chunks.
    return React.createElement(
      'p',
      {},
      finalArray.map((element) => {
        if (element === 1) {
          currentIndex += 1;
          // create span elements for dynamic values
          return React.createElement('span', {}, data.values[currentIndex]);
        }
        // create label elements for normal narration string
        return React.createElement('label', {}, `${element}`);
      }),
    );
  } catch (_error) {
    return <p />;
  }
}

GenerateNarration.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
